import { combineReducers } from 'redux';

import * as types from 'modules/dealerConfiguration/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import administration from './administration/reducer';
import general from './general/reducer';
import integrations from './integrations/reducer';
import sales from './sales/reducer';

/**
 * @typedef {{
 *   administration: import('./administration/reducer').DealerConfigurationGeneralReducer,
 *   general: import('./general/reducer').DealerConfigurationGeneralReducer,
 *   integrations: import('./integrations/reducer').DealerConfigurationIntegrationsReducer,
 *   isReady: boolean,
 * }} DealerConfigurationReducer
 */

export default combineReducers({
  sales,
  general,
  integrations,
  administration,
  isReady: createReducer(false, { [types.IS_CONFIG_READY]: (_, { payload }) => payload, })
});
